import { setLang } from '../lang'

const lang = new URLSearchParams(location.search).get('lang')
if (lang) {
	setLang(lang)
	window.history.replaceState({}, null, '/')
}
